(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- countdown ---------- */
  function countdown() {
    var host = $("[data-rl-cd]");
    if (!host) return;
    var target = new Date(host.getAttribute("data-target") || "2026-10-01T00:00:00").getTime();
    var els = {};
    $$("[data-cd]").forEach(function (el) { (els[el.getAttribute("data-cd")] = els[el.getAttribute("data-cd")] || []).push(el); });
    var set = function (k, v) { (els[k] || []).forEach(function (el) { el.textContent = v; }); };
    var paint = function () {
      var s = Math.floor(Math.max(0, target - Date.now()) / 1000);
      set("d", String(Math.floor(s / 86400)));
      set("h", String(Math.floor((s % 86400) / 3600)).padStart(2, "0"));
      set("m", String(Math.floor((s % 3600) / 60)).padStart(2, "0"));
      set("s", String(s % 60).padStart(2, "0"));
    };
    paint();
    setInterval(paint, 1000);
  }

  /* ---------- scroll reveal ---------- */
  function reveal() {
    var targets = [];
    $$("[data-rl-reveal]").forEach(function (sec) {
      var wrap = sec.firstElementChild && sec.firstElementChild.children.length > 1 ? sec.firstElementChild : sec;
      var kids = Array.prototype.slice.call(wrap.children).filter(function (el) { return el.offsetHeight > 0 || el.children.length; });
      var group = kids.length > 1 ? kids : [wrap];
      group.forEach(function (el, i) { el.style.setProperty("--rv-d", Math.min(i, 6) * 90 + "ms"); targets.push(el); });
    });
    if (!targets.length || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.setAttribute("data-rl-rv", "in"); obs.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.04 });
    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) el.setAttribute("data-rl-rv", "in");
      else { el.setAttribute("data-rl-rv", ""); obs.observe(el); }
    });
  }

  /* ---------- hero turntable ---------- */
  function hero() {
    var stage = $("[data-rl-stage]");
    var pad = $("[data-rl-turntable]");
    if (!stage || !pad) return;
    var frames = $$("[data-rl-frame]", pad);
    var turns = parseFloat(stage.getAttribute("data-turns") || "1.15");
    var headline = $("[data-rl-headline]");
    var glow = $("[data-rl-glow]");
    var fullLabel = $("[data-rl-fulllabel]");
    var caps = $$("[data-rl-stagecap]");
    var section = stage.closest("section");
    var scrollAngle = 0, dragAngle = 0, shown = -1, raf = null;

    frames.forEach(function (el) {
      var src = el.getAttribute("data-src");
      if (src) { var im = new Image(); im.src = src; el.style.backgroundImage = "url(" + src + ")"; }
    });

    function paint() {
      var total = frames.length; if (!total) return;
      var step = 360 / total;
      var a = (((scrollAngle + dragAngle) % 360) + 360) % 360;
      var i = Math.floor((a + step / 2) / step) % total;
      if (i === shown) return;
      frames.forEach(function (el, n) {
        var on = n === i;
        el.style.opacity = on ? "1" : "0";
        el.style.visibility = on ? "visible" : "hidden";
      });
      shown = i;
    }

    var dragging = false, lastX = 0;
    var down = function (e) { dragging = true; lastX = e.touches ? e.touches[0].clientX : e.clientX; pad.style.cursor = "grabbing"; };
    var move = function (e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      dragAngle += (x - lastX) * 0.7; lastX = x; paint();
    };
    var up = function () { dragging = false; pad.style.cursor = "grab"; };
    pad.addEventListener("mousedown", down);
    pad.addEventListener("touchstart", down, { passive: true });
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);

    function tick() {
      if (!section) return;
      var span = section.offsetHeight - window.innerHeight;
      var p = Math.max(0, Math.min(1, window.scrollY / (span || 1)));
      scrollAngle = p * 360 * turns;
      paint();
      var intro = Math.max(0, Math.min(1, p / 0.34));
      var introE = intro * intro * (3 - 2 * intro);
      var g = Math.max(0, Math.min(1, (p - 0.34) / 0.34));
      g = g * g * (3 - 2 * g);
      if (window.innerWidth < 860) g = 0;
      var wrap = stage.offsetParent || stage.parentElement;
      var bw = stage.offsetWidth, bh = stage.offsetHeight;
      var cw = wrap.clientWidth, ch = wrap.clientHeight;
      var dx = cw / 2 - (stage.offsetLeft + bw / 2);
      var dy = ch / 2 - (stage.offsetTop + bh / 2);
      var base = 0.94 + introE * 0.1;
      var full = Math.min((ch * 0.98) / bh, (cw * 0.92) / bw);
      var sc = base + (full - base) * g;
      stage.style.transform = "translate(" + dx * g + "px," + (dy * g - introE * 20 * (1 - g)) + "px) scale(" + sc + ")";
      if (headline) {
        headline.style.transform = "translateY(" + (-intro * 80 - g * 60) + "px)";
        headline.style.opacity = String(Math.max(0, 1 - intro * 1.25 - g));
      }
      if (glow) glow.style.opacity = String((0.55 + introE * 0.45) * (1 - g * 0.45));
      caps.forEach(function (el) { el.style.opacity = String(Math.max(0, 1 - g * 3)); });
      if (fullLabel) fullLabel.style.opacity = String(Math.max(0, (g - 0.45) / 0.35));
    }
    var onScroll = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; tick(); });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    tick();

    var v = $("[data-rl-hero-video]");
    if (v) { v.muted = true; v.playsInline = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
  }

  /* ---------- cross-fading image stacks ---------- */
  function crossfades() {
    $$("[data-rl-fade]").forEach(function (host) {
      var imgs = $$("img", host);
      if (imgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        i = (i + 1) % imgs.length;
        imgs.forEach(function (el, n) { el.style.opacity = n === i ? "1" : "0"; });
      }, 5200 + Math.random() * 1800);
    });
    var shots = $$("[data-rl-shot]");
    if (shots.length > 1) {
      var s = 0;
      setInterval(function () {
        s = (s + 1) % shots.length;
        shots.forEach(function (el, n) { el.style.opacity = n === s ? "1" : "0"; });
      }, 4200);
    }
  }

  /* ---------- archive toggle ---------- */
  function archive() {
    var btn = $("[data-rl-arch-toggle]");
    var more = $("[data-rl-arch-more]");
    if (!btn || !more) return;
    btn.addEventListener("click", function () {
      var open = more.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      $("[data-rl-arch-label]", btn).textContent = open ? btn.getAttribute("data-close") : btn.getAttribute("data-open");
    });
  }

  /* ---------- modals ---------- */
  function modals() {
    $$("[data-rl-modal-open]").forEach(function (t) {
      t.addEventListener("click", function () {
        var m = document.getElementById(t.getAttribute("data-rl-modal-open"));
        if (!m) return;
        m.hidden = false;
        var f = m.getAttribute("data-for-field");
        var src = t.getAttribute("data-product-title");
        if (f && src) { var el = $("[data-rl-modal-title]", m); if (el) el.textContent = src + " — notify me"; }
      });
    });
    $$("[data-rl-modal]").forEach(function (m) {
      m.addEventListener("click", function (e) { if (e.target === m || e.target.hasAttribute("data-rl-modal-close")) m.hidden = true; });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") $$("[data-rl-modal]").forEach(function (m) { m.hidden = true; });
    });
  }

  /* ---------- signup stubs (wire to your email tool / customer form) ---------- */
  function signups() {
    $$("[data-rl-signup]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (form.getAttribute("data-rl-signup") === "shopify") return; // real customer form posts
        e.preventDefault();
        var input = $("input[type=email]", form);
        var note = $("[data-rl-note]", form.parentNode) || $("[data-rl-note]", form);
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((input && input.value || "").trim());
        if (note) note.textContent = ok ? "You're on the list — watch your inbox." : "Enter a valid email.";
        if (ok && input) input.value = "";
      });
    });
  }

  /* ---------- product variant picker ---------- */
  function product() {
    var root = $("[data-rl-product]");
    if (!root) return;
    var data = JSON.parse($("[data-rl-variants]", root).textContent);
    var idField = $("[data-rl-variant-id]", root);
    var priceEl = $("[data-rl-price]", root);
    var addBtn = $("[data-rl-add]", root);
    var statusEl = $("[data-rl-status]", root);
    var mediaEl = $("[data-rl-main-image]", root);
    var selected = [];

    $$("[data-rl-option]", root).forEach(function (group) {
      var pos = parseInt(group.getAttribute("data-rl-option"), 10) - 1;
      var active = $(".rl-pill.is-active", group);
      selected[pos] = active ? active.getAttribute("data-value") : null;
      $$(".rl-pill", group).forEach(function (pill) {
        pill.addEventListener("click", function () {
          $$(".rl-pill", group).forEach(function (p) { p.classList.remove("is-active"); });
          pill.classList.add("is-active");
          selected[pos] = pill.getAttribute("data-value");
          var head = $("[data-rl-option-value]", group);
          if (head) head.textContent = pill.getAttribute("data-value");
          update();
        });
      });
    });

    function update() {
      var match = data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return selected[i] == null || selected[i] === o; });
      })[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (statusEl) statusEl.textContent = match.available ? data.openLabel : "Sold out";
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? data.addLabel : "Sold out";
      }
      if (mediaEl && match.image) mediaEl.src = match.image;
      if (window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", match.id);
        window.history.replaceState({}, "", u.toString());
      }
    }
    update();

    var chartBtn = $("[data-rl-chart-toggle]", root);
    var chart = $("[data-rl-chart]", root);
    if (chartBtn && chart) {
      chartBtn.addEventListener("click", function () {
        chart.hidden = !chart.hidden;
        chartBtn.textContent = chart.hidden ? "↕ View size chart" : "↕ Hide size chart";
      });
    }

    $$("[data-rl-thumb]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        if (mediaEl) mediaEl.src = b.getAttribute("data-src");
        $$("[data-rl-thumb]", root).forEach(function (o) { o.setAttribute("aria-current", "false"); });
        b.setAttribute("aria-current", "true");
      });
    });
  }

  function boot() { countdown(); reveal(); hero(); crossfades(); archive(); modals(); signups(); product(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();